// extracted by mini-css-extract-plugin
module.exports = {"button":"anchor_button__Nbgp1","underline":"anchor_underline__wELNZ","sale":"anchor_sale__q1qeR"};